

export const TECHNICIAN_VIDEO_REQUESTS_INITIATE_FETCH_VIDEO_REQUEST = 'TECHNICIAN_VIDEO_REQUESTS_INITIATE_FETCH_VIDEO_REQUEST';
export const TECHNICIAN_VIDEO_REQUESTS_FETCH_VIDEO_REQUEST_START = 'TECHNICIAN_VIDEO_REQUESTS_FETCH_VIDEO_REQUEST_START';
export const TECHNICIAN_VIDEO_REQUESTS_FETCH_VIDEO_REQUEST_SUCCESS = 'TECHNICIAN_VIDEO_REQUESTS_FETCH_VIDEO_REQUEST_SUCCESS';
export const TECHNICIAN_VIDEO_REQUESTS_FETCH_VIDEO_REQUEST_FAIL = 'TECHNICIAN_VIDEO_REQUESTS_FETCH_VIDEO_REQUEST_FAIL';
export const TECHNICIAN_VIDEO_REQUESTS_FETCH_VIDEO_REQUEST_RESET = 'TECHNICIAN_VIDEO_REQUESTS_FETCH_VIDEO_REQUEST_RESET';


